import { Injectable } from '@angular/core';
import { OrderService } from 'com.trumbull.phx.order.api-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderServiceService {

  constructor(private readonly orderService: OrderService) { }

  // getOrderInfo(provider: string, orderNumber: string): Observable<any> {
  //   return this.orderService.getOrder(provider, orderNumber); //Modify when general info code is available
  // }

  getOrderData(provider: string, orderNumber: string ) {
    // return this.orderService.getOrderData(provider, orderNumber); //Modify when general info code is available
  }
}
